import React from 'react'

import FaqSection from '../../../react4xp/components/FaqSection'

function FaqPart({title, intro, questions, isWhite, accordionColor}) {
	return (
		<FaqSection 
			title={title}
			desc={intro}
			accordion={questions}
			section={{
				bgColor: 'white'
			}}
			accordionColor={accordionColor}
			isWhite={isWhite}
		/>	
	)
}

export default (props) => <FaqPart {...props} />
